import { render, staticRenderFns } from "./Modulemove.vue?vue&type=template&id=625c2ab6&"
import script from "./Modulemove.vue?vue&type=script&lang=js&"
export * from "./Modulemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports